'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _ = require('..');

var _SocialLoginButtons = require('./SocialLoginButtons.scss');

var _SocialLoginButtons2 = _interopRequireDefault(_SocialLoginButtons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLoginButtons = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth
  };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SocialLoginButtons, _Component);

  function SocialLoginButtons() {
    (0, _classCallCheck3.default)(this, SocialLoginButtons);
    return (0, _possibleConstructorReturn3.default)(this, (SocialLoginButtons.__proto__ || (0, _getPrototypeOf2.default)(SocialLoginButtons)).apply(this, arguments));
  }

  (0, _createClass3.default)(SocialLoginButtons, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: _SocialLoginButtons2.default.socialLogin },
        _react2.default.createElement(_.AppleLoginButton, null),
        _react2.default.createElement(_.FacebookLoginButton, null),
        _react2.default.createElement(_.GoogleLoginButton, null),
        _react2.default.createElement(_.AmazonLoginButton, null)
      );
    }
  }]);
  return SocialLoginButtons;
}(_react.Component), _class2.propTypes = {
  auth: _react.PropTypes.object
}, _temp)) || _class);
exports.default = (0, _reactIntl.injectIntl)(SocialLoginButtons);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialLoginButtons/SocialLoginButtons.js
// module id = 1988
// module chunks = 0